import { EcrDefinitionsInfo } from "./EcrDefinitionsInfo";

export class MachineEcrCode {
    machineInstallationName: string = null;

    machineSerialNumber: string = null;

    ecrCode: EcrDefinitionsInfo = new EcrDefinitionsInfo();

    constructor() { }

    public parse(obj: any) {
        if (obj.MachineInstallationName)
            this.machineInstallationName = obj.MachineInstallationName;
        if (obj.MachineSerialNumber)
            this.machineSerialNumber = obj.MachineSerialNumber;
        if (obj.EcrCode) {
            this.ecrCode = new EcrDefinitionsInfo();
            this.ecrCode.parse(obj.EcrCode);
        }
    }

}